(function () {
  if (window.__skipHeroLoaded) return;
  window.__skipHeroLoaded = true;

  function init(rootEl) {
    if (rootEl.__skipHeroInited) return;
    rootEl.__skipHeroInited = true;

    var id = rootEl.dataset.sectionId;
    var PRE = parseFloat(rootEl.dataset.animPre);
    if (isNaN(PRE)) PRE = 1;
    var POST = parseFloat(rootEl.dataset.animPost);
    if (isNaN(POST)) POST = 2;

    var sec = document.getElementById('S' + id);
    var con = document.getElementById('SC' + id);
    var bot = document.getElementById('BT' + id);
    var hero = document.getElementById('H' + id);
    var foot = document.getElementById('F' + id);
    if (!sec || !con || !bot) return;

    var gl = document.getElementById('GL' + id);
    var gt = document.getElementById('GT' + id);
    var gb = document.getElementById('GB' + id);
    var ds = document.getElementById('DS' + id);
    var p1 = document.getElementById('P1' + id);
    var p2 = document.getElementById('P2' + id);
    var p3 = document.getElementById('P3' + id);
    var p4 = document.getElementById('P4' + id);

    var mob = window.innerWidth <= 768;
    var dots = ds ? [].slice.call(ds.querySelectorAll('.D')) : [];

    var vh = 0, secTop = 0, secH = 0, heroEnd = 0, p1End = 0, totalAnim = 0;
    var prevWidth = 0;

    function getDocOffset(el) {
      var top = 0;
      while (el) { top += el.offsetTop || 0; el = el.offsetParent; }
      return top;
    }

    function measure() {
      mob = window.innerWidth <= 768;
      if (vh === 0 || window.innerWidth !== prevWidth) {
        vh = window.innerHeight;
        prevWidth = window.innerWidth;
      }
      secTop = getDocOffset(sec);

      var panels = mob ? 1.5 : 2.5;
      secH = Math.round(vh * (1 + 0.5 + PRE + panels + POST));
      sec.style.height = secH + 'px';

      heroEnd = vh * 0.35;
      p1End = vh * 0.7;
      totalAnim = secH - vh;

      if (foot) foot.style.marginTop = '-' + vh + 'px';

      if (mob) {
        if (p1) p1.style.top = '60px';
        if (p2) { p2.style.bottom = '100px'; p2.style.top = 'auto'; }
        if (p3) p3.style.top = '60px';
        if (p4) { p4.style.bottom = '100px'; p4.style.top = 'auto'; }
      }
    }

    measure();

    var st = {
      conOn: false,
      conOp: -1,
      heroOp: -1,
      heroTy: -1,
      botTfm: '',
      panel: -1,
      dot: -1,
      glow: false
    };

    var rotCur = 0, rotTgt = 0;

    function setConOn(on) {
      if (on === st.conOn) return;
      if (on) con.classList.add('ON'); else con.classList.remove('ON');
      st.conOn = on;
    }

    function setConOp(v) {
      var iv = (v * 100 + 0.5) | 0;
      if (iv === st.conOp) return;
      con.style.opacity = iv === 100 ? '1' : iv === 0 ? '0' : (iv * 0.01) + '';
      st.conOp = iv;
    }

    function setHero(op, ty) {
      if (!hero) return;
      var iop = (op * 100 + 0.5) | 0;
      var ity = (ty + 0.5) | 0;
      if (iop !== st.heroOp) {
        hero.style.opacity = iop === 100 ? '1' : iop === 0 ? '0' : (iop * 0.01) + '';
        st.heroOp = iop;
      }
      if (ity !== st.heroTy) {
        hero.style.transform = ity === 0 ? 'none' : 'translateY(' + (-ity) + 'px)';
        st.heroTy = ity;
      }
    }

    function setBot(tfm) {
      if (tfm === st.botTfm) return;
      bot.style.transform = tfm;
      st.botTfm = tfm;
    }

    function setPanel(idx) {
      if (idx === st.panel) return;
      if (p1) { if (idx === 0) p1.classList.add('ON'); else p1.classList.remove('ON'); }
      if (p2) { if (idx === 1) p2.classList.add('ON'); else p2.classList.remove('ON'); }
      if (p3) { if (idx === 2) p3.classList.add('ON'); else p3.classList.remove('ON'); }
      if (p4) { if (idx === 3) p4.classList.add('ON'); else p4.classList.remove('ON'); }
      st.panel = idx;
    }

    function setDot(idx) {
      if (idx === st.dot || !dots.length) return;
      for (var i = 0; i < dots.length; i++) {
        if (i === idx) dots[i].classList.add('ON');
        else dots[i].classList.remove('ON');
      }
      st.dot = idx;
    }

    function setGlow(on) {
      if (on === st.glow || !gl) return;
      gl.style.display = on ? '' : 'none';
      st.glow = on;
    }

    function frame() {
      var sy = window.scrollY;
      var scrolled = sy - secTop;

      if (scrolled <= 0) {
        setHero(1, 0);
        setConOn(false);
        setConOp(0);
        setBot('translateY(40px)');
        rotCur = 0; rotTgt = 0;
        return;
      }

      if (scrolled < heroEnd) {
        var ht = scrolled / heroEnd;
        setHero(1 - ht, ht * 80);
        setConOn(false);
        setConOp(0);
        setBot('translateY(40px)');
        rotCur = 0; rotTgt = 0;
        return;
      }

      if (scrolled < p1End) {
        var bt = (scrolled - heroEnd) / (p1End - heroEnd);
        setHero(0, 80);
        setConOn(true);
        setConOp(bt);
        setBot('translateY(' + ((40 - bt * 40) | 0) + 'px)');
        rotCur = 0; rotTgt = 0;
        return;
      }

      setHero(0, 80);
      setConOn(true);

      if (totalAnim <= 0) return;
      var bScroll = scrolled - p1End;
      var bTotal = totalAnim - p1End;
      if (bTotal <= 0) return;
      var p = bScroll / bTotal;
      if (p < 0) p = 0;
      if (p > 1) p = 1;

      if (p >= 0.85) {
        setConOp(1 - (p - 0.85) / 0.15);
        if (p >= 1) setConOn(false);
      } else {
        setConOp(1);
      }

      rotTgt = mob ? p * 180 : p * 360;
      rotCur += (rotTgt - rotCur) * 0.12;
      var deg = (rotCur * 10 + 0.5) | 0;
      setBot('rotate(' + (deg * 0.1) + 'deg)');

      var pi = p >= 0.60 ? 3 : p >= 0.45 ? 2 : p >= 0.25 ? 1 : p > 0.05 ? 0 : -1;
      setPanel(pi);

      var di = (p * dots.length) | 0;
      if (di >= dots.length) di = dots.length - 1;
      setDot(di);

      if (!mob) {
        if (gt) gt.style.transform = 'translateX(-50%) translateX(' + (-(p * 60) | 0) + 'px)';
        if (gb) gb.style.transform = 'translateX(-50%) translateX(' + ((p * 60) | 0) + 'px)';
        if (gl) {
          var h = 30 + (170 * p) | 0;
          var gi = (8 + p * 10) | 0;
          gl.style.boxShadow = '0 0 180px 160px hsla(' + h + ',70%,40%,' + (gi * 0.01) + ')';
        }
      }
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          frame();
          ticking = false;
        });
      }
    }, { passive: true });

    var rTimer;
    window.addEventListener('resize', function () {
      clearTimeout(rTimer);
      rTimer = setTimeout(function () {
        measure();
        st.panel = -1;
        st.dot = -1;
        frame();
      }, 200);
    }, { passive: true });

    frame();
  }

  function discoverAll(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('[data-skip-hero]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { discoverAll(); });
  } else {
    discoverAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    discoverAll(e.target);
  });
})();
